import { jwtDecode } from "jwt-decode";

export default (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return undefined;
  }
};
